import { z } from "zod";

export const ReportReservationFilterSchema = z.object({
    property_id: z.string().uuid(), // Ensuring property_id is a valid UUID
    base_on: z.enum(["created_reservation", "checkin_date", "checkout_date"]), // Enforcing specific values
    room_type_id: z.string(), // Ensuring room_type_id is a string
});

export type ReportReservationFilterType = z.infer<typeof ReportReservationFilterSchema>;